module.exports = __webpack_public_path__ + "img/pv-image01.393d65d0.webp";